const STORAGE_KEY = "backCameraDeviceId";
const PATCH_FLAG = "__backCameraPatched";

const wantsEnvironment = (constraints) => {
  const video = constraints?.video;
  if (!video || typeof video !== "object") return false;
  const fm = video.facingMode;
  if (fm === "environment") return true;
  if (fm && typeof fm === "object") {
    return fm.exact === "environment" || fm.ideal === "environment";
  }
  return false;
};

const discoverBackCameraDeviceId = async (originalGetUserMedia) => {
  try {
    const stream = await originalGetUserMedia({
      video: { facingMode: { exact: "environment" } },
    });
    const [track] = stream.getVideoTracks();
    const deviceId = track?.getSettings?.()?.deviceId;
    stream.getTracks().forEach((t) => t.stop());
    if (deviceId) {
      sessionStorage.setItem(STORAGE_KEY, deviceId);
      console.log("[backCameraPatch] Discovered back camera deviceId");
      return deviceId;
    }
  } catch (e) {
    console.warn("[backCameraPatch] Back camera discovery failed:", e?.name);
  }
  return null;
};

const installBackCameraPatch = () => {
  if (!navigator?.mediaDevices?.getUserMedia) return;
  if (navigator.mediaDevices[PATCH_FLAG]) return;

  const original = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
  let inflightDiscovery = null;

  navigator.mediaDevices.getUserMedia = async function patchedGetUserMedia(constraints) {
    if (!wantsEnvironment(constraints)) {
      return original(constraints);
    }

    let deviceId = sessionStorage.getItem(STORAGE_KEY);
    if (!deviceId) {
      if (!inflightDiscovery) {
        inflightDiscovery = discoverBackCameraDeviceId(original).finally(() => {
          inflightDiscovery = null;
        });
      }
      deviceId = await inflightDiscovery;
    }

    if (!deviceId) {
      return original(constraints);
    }

    const upgradedVideo = { ...constraints.video, deviceId: { exact: deviceId } };
    delete upgradedVideo.facingMode;
    const upgraded = { ...constraints, video: upgradedVideo };

    try {
      return await original(upgraded);
    } catch (e) {
      if (e?.name === "OverconstrainedError" || e?.name === "NotFoundError") {
        sessionStorage.removeItem(STORAGE_KEY);
        return original(constraints);
      }
      throw e;
    }
  };

  Object.defineProperty(navigator.mediaDevices, PATCH_FLAG, { value: true });
  console.log("[backCameraPatch] Installed");
};

export { installBackCameraPatch };
